<div class="footerContent py-2">
    <div class="h6 m-0">Copyright © {{currentYear}} Innova Solutions, Inc. All Rights Reserved.</div>
</div>
<button *ngIf="!isLoginPage && !isUnAuthorizedPage" mat-fab color="accent" class="floating-button" (click)="openSupportDialog()">
    <span class="material-symbols-outlined icon-center">
        headset_mic
    </span>
</button>